module.exports = __webpack_public_path__ + "5112fae1b297711e0e056bc6dd3f928e.pdf";